export enum SpinnerPosition {
  CenterCenter = 'center-center',
  TopCenter = 'top-center',
}
